import React from "react";
import { Grid, Card, CardContent, Box, Skeleton } from "@mui/material";

/**
 * Malls Skeleton Loader Component
 */
export const MallsSkeletonLoader: React.FC = () => {
  return (
    <Grid container spacing={3}>
      {[...Array(6)].map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card sx={{ height: "100%" }}>
            <Skeleton variant="rectangular" height={180} />
            <CardContent sx={{ p: 3 }}>
              <Skeleton
                variant="text"
                width="70%"
                sx={{ fontSize: "1.5rem", mb: 1 }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 2,
                }}
              >
                <Skeleton variant="circular" width={16} height={16} />
                <Skeleton variant="text" width="50%" />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                  mb: 2,
                }}
              >
                <Skeleton
                  variant="rounded"
                  width={80}
                  height={24}
                  sx={{ borderRadius: 3 }}
                />
                <Skeleton
                  variant="rounded"
                  width={90}
                  height={24}
                  sx={{ borderRadius: 3 }}
                />
                <Skeleton
                  variant="rounded"
                  width={85}
                  height={24}
                  sx={{ borderRadius: 3 }}
                />
              </Box>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: 1 }}
              />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

/**
 * Stores Skeleton Loader Component
 */
export const StoresSkeletonLoader: React.FC = () => {
  return (
    <Grid container spacing={2}>
      {[...Array(6)].map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card sx={{ height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 2,
                }}
              >
                <Skeleton variant="circular" width={48} height={48} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Skeleton
                    variant="text"
                    width="70%"
                    sx={{ fontSize: "1.25rem", mb: 0.5 }}
                  />
                  <Skeleton variant="text" width="50%" sx={{ mb: 1 }} />
                  <Skeleton
                    variant="rounded"
                    width="40%"
                    height={20}
                    sx={{ borderRadius: 3 }}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

/**
 * Offers Skeleton Loader Component
 */
export const OffersSkeletonLoader: React.FC = () => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      {[...Array(6)].map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card sx={{ height: "100%", borderRadius: 2 }}>
            <Skeleton variant="rectangular" height={200} />
            <Box sx={{ p: 2 }}>
              <Skeleton
                variant="rounded"
                width="40%"
                height={24}
                sx={{ mb: 1.5 }}
              />
              <Skeleton
                variant="text"
                width="90%"
                sx={{ fontSize: "1.5rem", mb: 1 }}
              />
              <Skeleton
                variant="text"
                width="70%"
                sx={{ fontSize: "1.5rem", mb: 2 }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="50%" />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

/**
 * Events Skeleton Loader Component
 */
export const EventsSkeletonLoader: React.FC = () => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      {[...Array(6)].map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card sx={{ height: "100%", borderRadius: 2 }}>
            <Skeleton variant="rectangular" height={200} />
            <Box sx={{ p: 2 }}>
              <Skeleton
                variant="rounded"
                width="40%"
                height={24}
                sx={{ mb: 1.5 }}
              />
              <Skeleton
                variant="text"
                width="90%"
                sx={{ fontSize: "1.5rem", mb: 1 }}
              />
              <Skeleton
                variant="text"
                width="70%"
                sx={{ fontSize: "1.5rem", mb: 2 }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="text" width="55%" />
                <Skeleton variant="text" width="65%" />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
